export default {
    details: 'Aucun compte avec votre courriel a été trouvé sur {supplier}',
    goHome: "Aller à l'accueil",
    title: 'Compte {supplier} introuvable',
    deskit: 'Deskit',
};
